import { createEntityFilterStore } from "./createEntityFilterStore";
import type { ProjectFilters } from "@/domain/types";

const initialFilters: ProjectFilters = {
	search: "",
	promoter: "",
	subtype: "",
	status: "",
	documentation: "",
	sort: { key: undefined, direction: null },
};

export const useProjectFiltersStore = createEntityFilterStore<ProjectFilters>(
	"ProjectFiltersStore",
	initialFilters,
);
